import React, { ReactNode } from 'react'
import { Box, Popover } from '@mui/material'

interface CustomDensityMenuProps {
  anchorEl: HTMLElement | null
  children: ReactNode
  onClose: () => void
}

const CustomDensityMenu: React.FC<CustomDensityMenuProps> = ({ anchorEl, children, onClose }) => {
  return (
    <Popover
      open={Boolean(anchorEl)} // Ensure it only opens when anchorEl exists
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box sx={{ p: 2 }}>{children}</Box>
    </Popover>
  )
}

export default CustomDensityMenu
